import React from "react";

function Footer() {
  return (
    <div className="footer">
      <footer class="py-5 white fixed-bottom">
        <div class="container">
          <p class="m-0 text-center text-white">
            Copyright &copy; Your Website 2020
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Footer;